import { GameScoreDto } from "../models";
import { User } from "../modules/game/types";
import { UserType } from "./enums";

export const postMessageToParent = (message: Record<string, any>, targetOrigin: string = '*') => {
  if (window?.parent) {
    window.parent.postMessage(message, targetOrigin);
  }
};

export const playAudio = (src: string) => {
  if (window.isSoundEnabled === false) {
    return;
  }

  const audio = new Audio(src);
  audio.currentTime = 0;
  audio.play().catch((error) => {
    console.error('Ошибка воспроизведения аудио:', error);
  });
};

export const isUserCanReceivePoints = (user: User | undefined): boolean => {
  if (!user) return false;;

  try {
    const { details } = user;
    const { age, accountType } = details;

    const isKid = age < 14 && age >= 6;
    const isUserTypeOk = accountType === UserType.STANDARD || accountType === UserType.FULL;

    return isKid && isUserTypeOk;
  } catch (error) {
    console.error('Error in isUserCanReceivePoints:', error);
    return false;
  }
};

export const isUserReceivedPoints = (scoreData: GameScoreDto | undefined) => (scoreData?.goals?.length ?? 0) === 10;

export const isMobileDevice = () => {
  if (typeof navigator === 'undefined') return false;
  return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
};
